import { BroadcastMasksConfig } from "src/features/broadcastMasks/common/types";

export const loadBroadcastMasksConfigRequest = async (
  configUrl: string
): Promise<BroadcastMasksConfig> =>
  fetch(configUrl).then((resp) => resp.json());
